import { generateId } from "@fleet/utils";
import { bible_reading_progress, type PowerSyncDrizzleDB } from "@bso/powersync";
import { patchRowsVerified, patchRowVerified } from "../powersync/verified-write";

/**
 * Builds a NEW reading-progress row (the create path, shared by the hook and
 * the P106 B5 proof). The id is minted on the client as a UUIDv7
 * (`generateId`), matching the native `uuid` column of the reset baseline.
 */
export function buildReadingProgressRow(userId: string, planId: string, day: number) {
  const now = new Date().toISOString();
  return {
    id: generateId(),
    user_id: userId,
    plan_id: planId,
    day,
    created_at: now,
    updated_at: now,
    deleted_at: null,
  };
}

/**
 * UPDATE writes on `bible_reading_progress` — same window as
 * `../highlights/mutations.ts` (ver `../powersync/verified-write.ts`). El
 * specific risk: `completeDay` INSERTS a new row, and if the user
 * unchecks on tap (same check/uncheck gesture), `uncompleteDay`
 * looks up by id seconds later — right in the window. Extracted from
 * `apps/web/src/features/reading-plans/hooks/use-reading-progress.ts`.
 */

/** Restores the tombstone of a previously marked day (re-check). */
export async function restoreReadingProgressMutation(
  db: PowerSyncDrizzleDB,
  id: string,
): Promise<void> {
  await patchRowVerified(db, bible_reading_progress, bible_reading_progress.id, id, {
    deleted_at: null,
    updated_at: new Date().toISOString(),
  });
}

/** Soft-deletes (logical tombstone) all active rows for a day — uncheck. */
export async function softDeleteReadingProgressMutation(
  db: PowerSyncDrizzleDB,
  ids: readonly string[],
): Promise<void> {
  const now = new Date().toISOString();
  await patchRowsVerified(db, bible_reading_progress, bible_reading_progress.id, ids, {
    deleted_at: now,
    updated_at: now,
  });
}
